import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Shows a muted "view only" banner on tenant-settings pages when the
 * signed-in user is NOT an admin (not OWN/TSA/platform operator). Pages
 * use this to make the read-only state obvious; the actual edit/delete
 * controls are gated on isAdmin() separately so a non-admin never sees a
 * disabled-looking button they cannot use. Server-side authorization on
 * the tenant-service PATCH remains the real enforcement — this is UX.
 */
export function useIsAdmin() {
  const { isAdmin } = useAuth();
  return typeof isAdmin === "function" ? isAdmin() : false;
}

export default function ReadOnlyNotice({ what = "these settings" }) {
  const admin = useIsAdmin();
  if (admin) return null;
  return (
    <div
      className="mt-4 flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800"
      data-testid="readonly-notice"
    >
      <Lock className="h-4 w-4 shrink-0" />
      You have view-only access to {what}. Ask a tenant administrator to make changes.
    </div>
  );
}
